// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    DispatchBeginLoadDealers,
    DispatchCompleteLoadDealers,
    RequestDataFromApi,
    chain,
} from "@insite/client-framework/Store/Data/Dealers/Handlers/LoadDealer";
import { xGetDealer } from "@vanmeter/App/Services/XngDealerService";

export const XngDispatchBeginLoadDealers: typeof DispatchBeginLoadDealers = props => {
    props.dispatch({
        type: "Data/Dealers/BeginLoadDealer",
        key: props.parameter.id,
    });
};

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    props.apiResult = await xGetDealer(props.apiParameter);
    props.apiResult = { ...props.apiResult, id: props.apiParameter.id };
};

export const XngDispatchCompleteLoadDealers: typeof DispatchCompleteLoadDealers = props => {
    props.dispatch({
        type: "Data/Dealers/CompleteLoadDealer",
        model: props.apiResult,
        key: props.parameter.id,
    });
};

replaceInChain(chain, DispatchBeginLoadDealers, XngDispatchBeginLoadDealers);
replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
replaceInChain(chain, DispatchCompleteLoadDealers, XngDispatchCompleteLoadDealers);
